<template>
    <div class="absolute top-8 left-6 w-4 h-4 text-center" @click="goBack()">
        <img src="@/assets/icon/arrow/arrow-chevron-left.svg" class="mx-auto" alt />
    </div>
</template>

<script>
export default {
    name: "TopBarNavigation",
    props: {
        defaultBackBehavior: {
            type: Boolean,
            default: true
        },
    },
    emits: ["onClickBack"],
    methods: {
        goBack: function () {
            if (this.defaultBackBehavior) {
                this.$store.dispatch("setBackState")
                this.$router.go(-1)
            } else {
                this.$emit("onClickBack")
            }
        }
    }
}
</script>
